export const AGE_RANGE = {
  adult: [18, 120],
  dependant: [1, 17]
}

export const TRAVELLER_AGE_ERRORS = {
  required: 'Please enter an age',
  range: 'Please enter an age between 1 and 120',
  adultRequired: 'At least one adult aged 18 or over is required'
}

export const EXTRA_COVERS = [
  'Snow Sports',
  'Cruise'
]

export const DESTINATIONS = {}

export const MAX_TRIP_LENGTH = [
  {
    name: 'Up to 15 days',
    value: 15
  },
  {
    name: 'Up to 30 days',
    value: 30
  },
  {
    name: 'Up to 60 days',
    value: 60
  }
]

export const TRIP_CANCELLATION = [
  {
    name: 'any',
    value: 0
  },
  {
    name: '$1,000',
    value: 1000
  },
  {
    name: '$5,000',
    value: 5000
  },
  {
    name: '$10,000',
    value: 10000
  },
  {
    name: '$20,000',
    value: 20000
  }
]

export const LUGGAGE_COVER = [
  {
    name: 'any',
    value: 0
  },
  {
    name: '$2,000',
    value: 2000
  },
  {
    name: '$5,000',
    value: 5000
  },
  {
    name: '$10,000',
    value: 10000
  },
  {
    name: '$20,000',
    value: 20000
  }
]

export const MAXIMUM_EXCESS = [
  {
    name: 'any',
    value: 0
  },
  {
    name: '$100',
    value: 100
  },
  {
    name: '$250',
    value: 250
  },
  {
    name: '$500',
    value: 500
  }  
]

export const RENTAL_CAR_COVER = [
  {
    name: 'any',
    value: 0
  },
  {
    name: '$2,000',
    value: 2000
  },
  {
    name: '$4,000',
    value: 4000
  },
  {
    name: '$6,000',
    value: 6000
  }
]

export const FORM_MODEL_OBJ = {
  quoteType: 'single',
  destinations: [],
  adultAges: null,
  dependantAges: null,
  email: null,
  extraCovers: [],
  leavingDate: null,
  returnDate: null,
  commencementDate: null,
  maxTripLength: null
}

// CC-40297 — shown only in the mandatory email A/B test Variant
export const EMAIL_REQUIRED_ERROR = 'Please enter your email address'

export const ERROR_MAP = {
  destinations: 'Please select your destination(s)',
  adultAges: 'Please enter valid age',
  dependantAges: 'Please enter valid age',
  email: 'Please enter a valid email address',
  extraCovers: 'Please select an option',
  leavingDate: 'Please enter a valid date',
  returnDate: 'Please enter a valid date',
  commencementDate: 'Please enter a valid date',
  maxTripLength: 'Please select an option'
}